/**
 * Brand-equity loading state for the Marketer View — the circular spinner used
 * on the dashboard, instead of Antd's default four-dot Spin.
 */

import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

export const MarketerLoading: React.FunctionComponent = () => (
  <div style={{ textAlign: 'center', padding: '60px 0' }}>
    <Spin
      indicator={<LoadingOutlined style={{ fontSize: 42, color: '#3d5a80' }} spin />}
    />
  </div>
);
